import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import {
  faCheckCircle,
  faFileAlt,
  faTruckFast,
  faWarehouse,
  faTachometerAlt,
  faBell,
  faBan,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DashboardLayout from "../../components/customer/DashboardLayout";
import DashboardCard from "../../components/common/DashboardCard";
import {
  customerDashboardService,
  CustomerDashboardData,
} from "../../services/customer.dashboard.service";
import logoElpaketShort from "../../assets/images/logo-elpaket-short.png";
import "../../styles/app/Dashboard.css";
import btnStyles from "../../styles/components/Button.module.css";

const Dashboard: React.FC = () => {
  const { user, customerData } = useAuth();
  const navigate = useNavigate();
  const isVerify = localStorage.getItem("isVerify") === "true";

  const [dashboardData, setDashboardData] =
    useState<CustomerDashboardData | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await customerDashboardService.getDashboardData();
        if (response.statusCode === 200) {
          setDashboardData(response.data);
        }
      } catch (error) {
        console.error("Error fetching dashboard data", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchDashboardData();
  }, []);

  const stats = [
    {
      title: "Totales",
      value: isLoading ? "..." : (dashboardData?.ordersCount ?? 0).toString(),
      icon: faFileAlt,
      statusIds: [] as number[],
    },
    {
      title: "Recibidas",
      value: isLoading
        ? "..."
        : (dashboardData?.ordersOriginCount ?? 0).toString(),
      icon: faWarehouse,
      statusIds: [1],
    },
    {
      title: "En Tránsito",
      value: isLoading
        ? "..."
        : (dashboardData?.ordersInTransitCount ?? 0).toString(),
      icon: faTruckFast,
      logo: logoElpaketShort,
      isLogo: true,
      statusIds: [
        2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
        22, 23, 24, 25, 26, 27, 28, 38, 41, 44,
      ],
    },
    {
      title: "Entregados",
      value: isLoading
        ? "..."
        : (dashboardData?.ordersDeliveredCount ?? 0).toString(),
      icon: faCheckCircle,
      statusIds: [40],
    },
    {
      title: "Anuladas",
      value: isLoading
        ? "..."
        : (dashboardData?.ordersVoided ?? 0).toString(),
      icon: faBan,
      statusIds: [49],
    },
  ];

  const recentActivities = [
    {
      id: 1,
      message: "Tu envío #54321 ha sido actualizado a: En Tránsito.",
      time: "Hace 20 min",
    },
    {
      id: 2,
      message:
        "Tu envío #54320 fue entregado. ¡Gracias por confiar en nosotros!",
      time: "Hace 2 horas",
    },
  ];

  const getGreetingName = () => {
    if (customerData?.FirstName) return customerData.FirstName;
    if (user?.displayName) return user.displayName.split(" ")[0];
    return "Usuario";
  };

  return (
    <DashboardLayout>
      <DashboardCard
        icon={faTachometerAlt}
        title={`¡Bienvenido, ${customerData?.FirstName} ${customerData?.LastName}!`}
        description="Aquí tienes un resumen de tus envíos y actividad reciente."
        actions={
          <button
            className={btnStyles.primary}
            onClick={() => navigate("/customer/send-package")}
          >
            <FontAwesomeIcon icon={faPlus} />
            Crear Envío
          </button>
        }
        showVerificationAlerts={true}
      />

      <p className="stats-section-title">Ordenes</p>
      <hr className="stats-section-divider" />
      <div className="stats-grid">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="stat-card"
            style={{ cursor: "pointer" }}
            onClick={() => {
              const baseRoute = "/customer/my-orders?clearDates=true";
              if (stat.statusIds.length > 0) {
                navigate(`${baseRoute}&status=${stat.statusIds.join(",")}`);
              } else {
                navigate(baseRoute);
              }
            }}
          >
            <div className="stat-card-info">
              <p className="stat-title">{stat.title}</p>
              <p className="stat-value">{stat.value}</p>
            </div>
            <div className="stat-icon-wrapper">
              {stat.isLogo && stat.logo ? (
                <img src={stat.logo} alt={stat.title} className="logo-elpaket-small" />
              ) : (
                <FontAwesomeIcon icon={stat.icon} className="stat-icon" />
              )}
            </div>
          </div>
        ))}
      </div>
      {/* 
      <div className="activity-card">
        <div className="card-header">
          <h3 className="card-title">Actividad Reciente</h3>
        </div>
        <div className="card-body">
          <div className="activity-list">
            {recentActivities.map((activity) => (
              <div key={activity.id} className="activity-item">
                <div className="activity-icon-wrapper">
                  <FontAwesomeIcon icon={faBell} className="activity-icon" />
                </div>
                <div>
                  <p className="activity-message">{activity.message}</p>
                  <p className="activity-time">{activity.time}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      */}
    </DashboardLayout>
  );
};

export default Dashboard;
